'use client';

import dynamic from 'next/dynamic';
import {
  FaFacebookF,
  FaFacebookMessenger,
  FaLinkedinIn,
  FaTelegramPlane,
  FaViber,
  FaVk,
  FaWhatsapp,
  FaXing,
} from 'react-icons/fa';
import { RiTwitterXFill } from 'react-icons/ri';

import { ShareOption } from './config';

interface SharePlatform {
  Component: any;
  Icon: any;
}

const platforms: Record<ShareOption, SharePlatform> = {
  facebook: {
    Component: dynamic(async () => (await import('react-share')).FacebookShareButton),
    Icon: FaFacebookF,
  },
  messenger: {
    Component: dynamic(async () => (await import('react-share')).FacebookMessengerShareButton),
    Icon: FaFacebookMessenger,
  },
  twitter: {
    Component: dynamic(async () => (await import('react-share')).TwitterShareButton),
    Icon: RiTwitterXFill,
  },
  linkedin: {
    Component: dynamic(async () => (await import('react-share')).LinkedinShareButton),
    Icon: FaLinkedinIn,
  },
  whatsapp: {
    Component: dynamic(async () => (await import('react-share')).WhatsappShareButton),
    Icon: FaWhatsapp,
  },
  telegram: {
    Component: dynamic(async () => (await import('react-share')).TelegramShareButton),
    Icon: FaTelegramPlane,
  },
  viber: {
    Component: dynamic(async () => (await import('react-share')).ViberShareButton),
    Icon: FaViber,
  },
  xing: {
    Component: dynamic(async () => (await import('./XingShareButton')).default),
    Icon: FaXing,
  },
  vk: {
    Component: dynamic(async () => (await import('react-share')).VKShareButton),
    Icon: FaVk,
  },
};

interface ArticleShareButtonProps {
  className?: string;
  url: string;
  option: ShareOption;
}

export default function ArticleShareButton({ className, url, option }: ArticleShareButtonProps) {
  const { Component, Icon } = platforms[option];

  return (
    <Component url={url} className={className}>
      <div className="block h-8 w-8 rounded-full bg-gray-200 p-2 text-premium-dark transition-all hover:scale-110 hover:bg-gray-500">
        <Icon className="h-4 w-4" />
      </div>
    </Component>
  );
}
